import getCardNoDetailService from '../services/components/card_no_service'

const getState = (cardDetailState) => ({ type: "CARD_NO_DETAILSTATE", cardDetailState})

export const getCardNoDetailsAction = (cardNo, toggler) => dispatch => {
    let state = []
    getCardNoDetailService((data, msg) => {
        if (msg === "success") {
            state = {
                message: "Success",
                status: 200,
                body: data
            }
        }
        else if (msg === "error") {
            state = {
                message: "Empty Body",
                status: 204,
                body: data
            }
        }
        else if(msg === "sessionout"){
            state={
                message: "sessionout",
                status: 401,
                body: data
            }
        }
        dispatch(getState(state))
    }, cardNo, toggler)
}


// WEBPACK FOOTER //
// ./src/actions/getCardNoDetailsAction.js